import { when } from '@execonline-inc/maybe-adapter';
import { eq } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import ImportParticipantsStore from '../../Store';
import { ImportedParticipants } from '../../Store/Types';
import FailedAlertImport from './Shared/FailedAlertImport';
import SuccessImport from './SuccessImport';

interface Props {
  importedParticipants: ImportedParticipants;
  totalCount: number;
  store: ImportParticipantsStore;
}

const importSucceeds = (total: number, successful: number) => when(eq(total)(successful), {});

function ImportStatus({ importedParticipants, totalCount, store }: Props) {
  const { successfulParticipants } = importedParticipants;
  const successfulParticipantsCount = successfulParticipants.length;

  return importSucceeds(totalCount, successfulParticipantsCount)
    .map(() => (
      <SuccessImport
        successfulParticipants={successfulParticipants}
        totalCount={totalCount}
        store={store}
      />
    ))
    .getOrElse(() => (
      <FailedAlertImport
        importedParticipants={importedParticipants}
        totalCount={totalCount}
        store={store}
      />
    ));
}

export default observer(ImportStatus);
